<template>
  <section class="widget ad-interactions">
    <h3 class="widget-title">
      Más detalles de tus anuncios en {{ $route.params.productName }}
    </h3>
    <card>
      <div class="interaction-wrapper">
        <div
          class="interaction-item"
          v-for="(adInteraction, index) in adInteractions.slice(0,limitItems)"
          :key="index"
        >
          <span class="icon-wrapper">
            <font-awesome-icon :icon="adInteraction.Icon" />
          </span>
          <p class="highlight">
            {{ Number(adInteraction.ClicksCount || 0).toLocaleString() }}
          </p>
          <small>{{ adInteraction.Description }}</small>
        </div>
      </div>
      <div class="view-more">
        <button v-if="adInteractions.length > 5" @click="viewMoreItems">
          Ver {{viewMoreButtonMessage}}
        </button>
      </div>
    </card>
  </section>
</template>
<script>

export default {
  name: "ad-interactions",
  props: {
    adInteractions: Array
  },
  data(){
    return{
      isCollapsed: false,
      limitItems: 5,
      viewMoreButtonMessage: "más +"
    }
  },
  methods:{
    viewMoreItems(){
      this.isCollapsed = !this.isCollapsed;
      if(this.isCollapsed){
        this.limitItems = this.adInteractions.length;
        this.viewMoreButtonMessage = "menos -"
      }else{
        this.limitItems = 5;
        this.viewMoreButtonMessage = "más +"
      }

    }
  },
};

</script>

<style lang="scss" scoped>

.interaction-wrapper {
  display: grid;
  grid-template-columns: repeat(5,1fr);
  text-align: center;
  .interaction-item {
    margin: 20px 0;
    .icon-wrapper {
      width: 40px;
      height: 40px;
      background-color: $blueish-gray-100;
      display: flex;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      margin: 0 auto 6px;
      color: $blueish-gray-600;
    }
    p {
      margin-bottom: 0;
    }
    small{
      font-size: 13px;
      line-height: .4rem;
    }
    margin-bottom: 20px;
    
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
}

@media screen and (max-width:725px) {
  .interaction-wrapper{
    display: grid;
  grid-template-columns: repeat(3,1fr);
  text-align: center;
  }
}

.view-more{
  margin-top: 20px ;
  display: flex;
  justify-content: center;
  button{
    color: #3ab8ff;
    font-size: 14px;
    cursor: pointer;
  }
}

@include respond-above(sm) {
  .interaction-wrapper {
   display: grid;
  grid-template-columns: repeat(5,1fr);
  text-align: center;
    .interaction-item {
      width: 105px;
      position: relative;
      padding: 0px 30px;
      margin-bottom: 0px;
      
      &:nth-child(5n) {
        border-right: none;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
